import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import {
  FiMinus,
  FiMaximize2,
  FiX,
  FiPaperclip,
  FiImage,
  FiLink,
  FiSmile,
  FiTrash
} from "react-icons/fi";

const ComposeModal = ({ show, closeModal }) => {

  const [minimized, setMinimized] = useState(false);
  const [maximized, setMaximized] = useState(false);

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        width: maximized ? "80%" : "520px",
        height: minimized ? "50px" : "auto",
        background: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
        zIndex: 9999
      }}
    >

      {/* Header */}
      <div
        style={{
          background: "#1e1e1e",
          color: "#fff",
          padding: "10px 15px",
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px"
        }}
        className="d-flex justify-content-between align-items-center"
      >
        <span>Compose New Email</span>

        <div>

          <FiMinus
            style={{ cursor: "pointer", marginRight: 10 }}
            onClick={() => setMinimized(!minimized)}
          />

          <FiMaximize2
            style={{ cursor: "pointer", marginRight: 10 }}
            onClick={() => setMaximized(!maximized)}
          />

          <FiX style={{ cursor: "pointer" }} onClick={closeModal} />

        </div>
      </div>

      {!minimized && (
        <>
          {/* Body */}
          <div style={{ padding: 15 }}>

            <Form.Group className="mb-3">
              <Form.Label>To</Form.Label>
              <Form.Control placeholder="Enter email" />
            </Form.Group>

            <Form.Control
              className="mb-3"
              placeholder="Subject"
            />

            <Form.Control
              as="textarea"
              rows={6}
              placeholder="Compose Email"
            />

          </div>

          {/* Footer */}
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ padding: 15 }}
          >
            <div>

              <Button variant="light" size="sm">
                <FiPaperclip />
              </Button>

              <Button variant="light" size="sm" className="ms-2">
                <FiImage />
              </Button>

              <Button variant="light" size="sm" className="ms-2">
                <FiLink />
              </Button>

              <Button variant="light" size="sm" className="ms-2">
                <FiSmile />
              </Button>

            </div>

            <div>

              <Button variant="light" size="sm">
                <FiTrash />
              </Button>

              <Button
                style={{
                  background: "#ff6b1a",
                  border: "none",
                  marginLeft: "10px"
                }}
              >
                Send →
              </Button>

            </div>
          </div>
        </>
      )}

    </div>
  );
};

export default ComposeModal;